<device-firmware>
  <div if={ props.isAdmin } class="card h-100 device-detail-support-card">
      <div class="card-header bg-white d-flex justify-content-between align-items-center">
        <span class="fw-semibold">Firmwares Disponibles</span>
        <!-- NUEVO: Indicador FOTA activo -->
        <span if={ state.fotaStatus } class="badge ms-2 { getFotaBadgeClass() }" title={ getFotaStatusTooltip() }>
          <i class={ getFotaBadgeIconClass() }></i> { getFotaBadgeLabelText() } <span if={ state.fotaDetail }>: { state.fotaDetail }</span>
        </span>
      </div>
      <div class="card-body device-detail-support-card-body">
        <!-- Loading spinner for firmwares -->
        <div if={ state.firmwareLoading } class="text-center my-4">
          <div class="spinner-border text-secondary" role="status">
            <span class="visually-hidden">Cargando...</span>
          </div>
          <p class="mt-2 text-muted">Cargando firmwares...</p>
        </div>
        <!-- Firmware error message -->
        <div if={ state.firmwareError } class="alert alert-warning">
          <i class="bi bi-exclamation-triangle me-2"></i> Error al cargar firmwares: { state.firmwareErrorMessage } <button type="button" class="btn btn-sm btn-outline-warning ms-2" onclick={ loadAvailableFirmwares }>
            <i class="bi bi-arrow-repeat me-1"></i> Reintentar </button>
        </div>
        <!-- Firmware list/selector -->
        <div if={ !state.firmwareLoading && !state.firmwareError && state.availableFirmwares }>
          <div if={ state.availableFirmwares.data && state.availableFirmwares.data.length> 0 }> <div class="mb-3">
              <label for="firmwareSelect-{ state.instanceId }" class="form-label">Seleccionar versión:</label>
              <select class="form-select" id="firmwareSelect-{ state.instanceId }" name="selectedFirmwareId" onchange={ (e)=> update({ selectedFirmwareId: e.target.value }) } value={ state.selectedFirmwareId }> <option value="" selected disabled>-- Elige un firmware --</option>
                <option each={ fw in state.availableFirmwares.data } value={ fw._id }> { fw.version } ({ fw.name || 'N/D' }) - { formatDate(fw.uploadTimestamp) } </option>
              </select>
            </div>
          </div>
          <div if={ !state.availableFirmwares.data || state.availableFirmwares.data.length===0 } class="text-center text-muted py-3">
            <i class="bi bi-box-seam" style="font-size: 1.5rem;"></i>
            <p class="mb-0 mt-1">No hay firmwares disponibles registrados.</p>
          </div>
        </div>
        <!-- Botón FOTA -->
        <div if={ !state.firmwareLoading && !state.firmwareError && state.availableFirmwares && state.availableFirmwares.data && state.availableFirmwares.data.length > 0 }>
          <button class="btn btn-primary mt-3" onclick={ handleStartFota } disabled={ !state.selectedFirmwareId || state.fotaStarting || isFotaInProgress() || !props.isOnline }>
            <i class="bi bi-upload me-1"></i> { state.fotaStarting ? 'Iniciando...' : 'Iniciar Actualización FOTA' }
          </button>
          <small if={ !props.isOnline } class="ms-2 text-warning">(Dispositivo offline)</small>
          <small if={ isFotaInProgress() } class="ms-2 text-info">(Actualización FOTA en curso)</small>
        </div>
        <!-- Fin Botón FOTA -->
        <!-- Indicadores de estado FOTA: sólo RECEIVED/ERROR/SUCCESS/FAILURE -->
      </div>
    </div>
    <!-- ADD NEW - Alert FOTA Status -->
    <div if={ state.fotaAlertVisible } class="alert alert-{ state.fotaAlertType } alert-dismissible fade show mt-3" role="alert"> { state.fotaAlertMessage } <button type="button" class="btn-close" onclick={ ()=> this.update({ fotaAlertVisible: false }) } aria-label="Close"></button>
    </div>
    <!-- END NEW -->
  </div>
  <script>
    import {
      webSocketService
    } from '../services/WebSocketService'; // Importar WS Service
    import {
      FirmwareService,
      DeviceService
    } from '../services';
    import {
      ToastService
    } from '../services/toast-service';
    export default {
      props: {
        deviceId: String,
        isAdmin: Boolean,
        isOnline: Boolean,
        deviceApp: String,
        deviceCity: String,
        deviceName: String
      },
      state: {
        instanceId: Date.now() + Math.random().toString(16).substring(2),
        availableFirmwares: null,
        firmwareLoading: false,
        firmwareError: false,
        firmwareErrorMessage: '',
        selectedFirmwareId: '',
        fotaStarting: false, // Indica si estamos ESPERANDO la respuesta de inicio
        // --- NUEVO ESTADO FOTA ---
        fotaStatus: null, // Estado FOTA (RECEIVED, ERROR, SUCCESS, FAILURE)
        fotaDetail: null, // Detalle FOTA (%, versión, mensaje error)
        watcherDeviceId: null, // ID esperado en mensajes WS (app/city/name)
        // --- FIN NUEVO ESTADO FOTA ---
        fotaAlertVisible: false,
        fotaAlertType: 'info',
        fotaAlertMessage: '',
      },
      onMounted() {
        if (this.props.isAdmin) {
          this.loadAvailableFirmwares();
          // Construir ID para mensajes WS
          if (this.props.deviceApp && this.props.deviceCity && this.props.deviceName) {
            this.state.watcherDeviceId = `${this.props.deviceApp}/${this.props.deviceCity}/${this.props.deviceName}`;
          } else {
            console.warn(`[DeviceFirmware ${this.props.deviceId}] Faltan props app/city/name para identificar mensajes FOTA.`);
            // Sin esto, no podremos procesar mensajes FOTA por WS
          }
          // Suscribirse a mensajes WS
          webSocketService.on('messageReceived', this.handleWebSocketMessage);
        }
      },
      onUnmounted() {
        if (this.props.isAdmin) {
          // Desuscribirse
          webSocketService.off('messageReceived', this.handleWebSocketMessage);
        }
      },
      // --- NUEVO: Manejador de Mensajes WebSocket ---
      handleWebSocketMessage(message) {
        if (message.type !== 'fota_status' || !this.state.watcherDeviceId) {
          return;
        }

        const payload = message.payload || message;
        const payloadDeviceId = payload.deviceId || (payload.app && payload.city && payload.name ? `${payload.app}/${payload.city}/${payload.name}` : null);

        if (payloadDeviceId !== this.state.watcherDeviceId) {
          return;
        }

        console.log(`[DeviceFirmware ${this.props.deviceId}] Received FOTA status:`, payload);
        this.update({
          fotaStatus: payload.status,
          fotaDetail: payload.detail || null
        });
        this.showFotaAlert(payload.status, payload.detail);
      },
      // --- NUEVO: Helper para mostrar alertas FOTA ---
      showFotaAlert(status, detail) {
        let message = `Estado FOTA: ${status}`;
        let type = 'info';
        switch (status) {
          case 'RECEIVED':
            message = 'Dispositivo ha recibido la solicitud FOTA.';
            type = 'info';
            break;
          case 'SUCCESS':
            message = `Actualización FOTA completada con éxito. Versión: ${detail || '?'}`;
            type = 'success';
            break;
          case 'ERROR':
            message = `Error durante la actualización FOTA: ${detail || 'Error desconocido'}`;
            type = 'danger';
            break;
          case 'FAILURE':
            message = `Fallo durante la actualización FOTA: ${detail || 'Fallo desconocido'}`;
            type = 'danger';
            break;
          default:
            message = `Estado FOTA desconocido: ${status} ${detail || ''}`.trim();
            type = 'warning';
        }
        this.update({
          fotaAlertVisible: true,
          fotaAlertType: type,
          fotaAlertMessage: message
        });
      },
      // --- NUEVO: Helper para limpiar estado FOTA ---
      clearFotaState() {
        this.update({
          fotaStatus: null,
          fotaDetail: null,
          fotaAlertVisible: false // Ocultar alerta también
        });
      },
      // --- NUEVO: Helper para saber si FOTA está activo ---
      isFotaInProgress() {
        return this.state.fotaStatus === 'RECEIVED';
      },
      getFotaStatusTooltip() {
        let tooltip = `Estado FOTA: ${this.state.fotaStatus}`;
        if (this.state.fotaDetail) {
          tooltip += ` - ${this.state.fotaDetail}`;
        }
        return tooltip;
      },
      // --- NUEVOS Helpers para el badge FOTA ---
      getFotaBadgeClass() {
        switch (this.state.fotaStatus) {
          case 'RECEIVED':
            return 'bg-info text-dark'; // text-dark for better contrast on info
          case 'ERROR':
          case 'FAILURE':
            return 'bg-danger';
          case 'SUCCESS':
            return 'bg-success';
          default:
            return 'bg-secondary'; // Para estados desconocidos o no manejados explícitamente
        }
      },
      getFotaBadgeIconClass() {
        switch (this.state.fotaStatus) {
          case 'RECEIVED':
            return 'bi bi-arrow-repeat me-1';
          case 'ERROR':
          case 'FAILURE':
            return 'bi bi-x-circle-fill me-1';
          case 'SUCCESS':
            return 'bi bi-check-circle-fill me-1';
          default:
            return 'bi bi-question-circle me-1';
        }
      },
      getFotaBadgeLabelText() {
        let label = "FOTA";
        switch (this.state.fotaStatus) {
          case 'RECEIVED':
            label = 'FOTA Solicitud Recibida';
            break;
          case 'ERROR':
            label = 'FOTA Error';
            break;
          case 'FAILURE':
            label = 'FOTA Fallido';
            break;
          case 'SUCCESS':
            label = 'FOTA Completado';
            break;
          default:
            label = 'FOTA Estado'; // Etiqueta genérica para estados no cubiertos explícitamente
            break;
        }
        // Incluimos el estado literal para mayor claridad, a menos que sea muy redundante.
        // Por ejemplo, "FOTA Completado: SUCCESS"
        return `${label}: ${this.state.fotaStatus}`;
      },
      // --- FIN Helpers para el badge FOTA ---
      async loadAvailableFirmwares() {
        this.update({
          firmwareLoading: true,
          firmwareError: false,
          firmwareErrorMessage: ''
        });
        try {
          // TODO: Consider adding fw_name filter based on device if necessary
          const firmwares = await FirmwareService.listFirmwares({
            limit: 100,
            sortBy: 'uploadTimestamp',
            sortOrder: 'desc'
          });
          this.update({
            availableFirmwares: firmwares,
            firmwareLoading: false
          });
        } catch (error) {
          console.error('Error al cargar firmwares disponibles:', error);
          this.update({
            firmwareLoading: false,
            firmwareError: true,
            firmwareErrorMessage: error.message || 'Error desconocido'
          });
        }
      },
      async handleStartFota(e) {
        e.preventDefault();
        const firmwareId = this.state.selectedFirmwareId;
        const deviceId = this.props.deviceId;
        // Limpiar estado FOTA previo y alerta
        this.clearFotaState();
        if (!deviceId || !firmwareId || !this.props.isOnline || this.isFotaInProgress()) {
          // Las validaciones individuales se hacen abajo, pero añadimos chequeo FOTA in progress
          if (this.isFotaInProgress()) ToastService.show('Ya hay una actualización FOTA en curso para este dispositivo.', 'warning');
          if (!this.props.isOnline) ToastService.show('El dispositivo debe estar online para iniciar FOTA.', 'warning');
          if (!firmwareId) ToastService.show('Por favor, selecciona un firmware para actualizar.', 'warning');
          if (!deviceId) ToastService.show('Error interno: ID de dispositivo no proporcionado.', 'danger');
          return;
        }
        this.update({
          fotaStarting: true
        }); // Indicar que estamos iniciando
        try {
          const response = await DeviceService.startFotaUpdate(deviceId, firmwareId);
          // La respuesta del servicio ya viene del bridge/dispositivo (ACK)
          if (response && response.success) {
            // Mostrar estado RECEIVED inmediatamente y reflejar en UI
            this.update({ fotaStatus: 'RECEIVED', fotaDetail: null });
            this.showFotaAlert('RECEIVED');
          } else {
            // Falló el inicio (API, bridge, o dispositivo rechazó/timeout)
            const errorMessage = response?.message || 'Error al iniciar FOTA (respuesta inesperada o timeout).';
            this.showFotaAlert('ERROR', errorMessage); // Usar el estado ERROR
            ToastService.show(errorMessage, 'danger');
          }
        } catch (error) {
          console.error(`[DeviceFirmware ${this.props.deviceId}] Error starting FOTA API call:`, error);
          const errorMessage = `Error al contactar la API para iniciar FOTA: ${error.message || 'Error desconocido'}`;
          // Mostrar error directamente en la alerta
          this.showFotaAlert('ERROR', errorMessage);
          ToastService.show(errorMessage, 'danger');
        } finally {
          this.update({
            fotaStarting: false
          }); // Dejar de indicar "Iniciando..."
        }
      },
      formatDate(timestamp) {
        if (!timestamp) return 'Fecha desconocida';
        const date = new Date(timestamp);
        return new Intl.DateTimeFormat('es-ES', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        }).format(date);
      }
    };
  </script>
</device-firmware>
